import { render, staticRenderFns } from "./baseInfoSubmit.vue?vue&type=template&id=14e99135"
import script from "./baseInfoSubmit.vue?vue&type=script&lang=js"
export * from "./baseInfoSubmit.vue?vue&type=script&lang=js"
import style0 from "./baseInfoSubmit.vue?vue&type=style&index=0&id=14e99135&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports